export const cube3x3x3LLFaceSVG = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="204px" height="204px" viewBox="30 30 196 196" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <title>3x3x3 LL</title>
  <defs>
    <g id="sticker">
        <rect x="-10" y="-10" width="1" height="1" stroke="black" stroke-width="0.04px" />
    </g>
  </defs>
  <g id="3x3x3-LL" stroke="none" stroke-width="4" style="none" stroke-linejoin="round">
    <rect x="32" y="32" width="192" height="192" stroke="black" stroke-width="16px" />
    <rect id="CENTERS-l0-o0" stroke="#000000" style="fill: white" x="96" y="96" width="64" height="64"></rect>
    <rect id="CENTERS-l0-o1" stroke="#000000" style="fill: white" x="96" y="96" width="64" height="64"></rect>
    <rect id="CENTERS-l0-o2" stroke="#000000" style="fill: white" x="96" y="96" width="64" height="64"></rect>
    <rect id="CENTERS-l0-o3" stroke="#000000" style="fill: white" x="96" y="96" width="64" height="64"></rect>

    <rect id="CORNERS-l0-o0" stroke="#000000" style="fill: white" x="160" y="160" width="64" height="64"></rect>
    <rect id="CORNERS-l1-o0" stroke="#000000" style="fill: white" x="160" y="32" width="64" height="64"></rect>
    <rect id="CORNERS-l2-o0" stroke="#000000" style="fill: white" x="32" y="32" width="64" height="64"></rect>
    <rect id="CORNERS-l3-o0" stroke="#000000" style="fill: white" x="32" y="160" width="64" height="64"></rect>

    <rect id="EDGES-l0-o0" stroke="#000000" style="fill: white" x="96" y="160" width="64" height="64"></rect>
    <rect id="EDGES-l1-o0" stroke="#000000" style="fill: white" x="160" y="96" width="64" height="64"></rect>
    <rect id="EDGES-l2-o0" stroke="#000000" style="fill: white" x="96" y="32" width="64" height="64"></rect>
    <rect id="EDGES-l3-o0" stroke="#000000" style="fill: white" x="32" y="96" width="64" height="64"></rect>
  </g>
  <g style="opacity: 0">
    <polygon id="CORNERS-l0-o1" stroke="#000000" style="fill: red" points="224 160 252 160 252 252 224 224"></polygon>
    <polygon id="CORNERS-l0-o2" stroke="#000000" style="fill: limegreen" transform="translate(206, 238) scale(1, -1) rotate(-90) translate(-206, -238) " points="192 192 220 192 220 284 192 256"></polygon>
    <polygon id="CORNERS-l1-o1" stroke="#000000" style="fill: #26f" transform="translate(206, 18) rotate(-90) translate(-206, -18) " points="192 -28 220 -28 220 64 192 36"></polygon>
    <polygon id="CORNERS-l1-o2" stroke="#000000" style="fill: red" transform="translate(238, 50) scale(1, -1) translate(-238, -50) " points="224 4 252 4 252 96 224 68"></polygon>
    <polygon id="CORNERS-l2-o1" stroke="#000000" style="fill: orange" transform="translate(18, 50) scale(-1, -1) translate(-18, -50) " points="4 4 32 4 32 96 4 68"></polygon>
    <polygon id="CORNERS-l2-o2" stroke="#000000" style="fill: #26f" transform="translate(50, 18) scale(1, -1) rotate(90) translate(-50, -18) " points="36 -28 64 -28 64 64 36 36"></polygon>
    <polygon id="CORNERS-l3-o1" stroke="#000000" style="fill: limegreen" transform="translate(50, 238) rotate(90) translate(-50, -238) " points="36 192 64 192 64 284 36 256"></polygon>
    <polygon id="CORNERS-l3-o2" stroke="#000000" style="fill: orange" transform="translate(18, 206) scale(-1, 1) translate(-18, -206) " points="4 160 32 160 32 252 4 224"></polygon>

    <rect id="EDGES-l0-o1" stroke="#000000" style="fill: limegreen" transform="translate(128, 238) scale(1, -1) rotate(90) translate(-128, -238) " x="114" y="206" width="28" height="64"></rect>
    <rect id="EDGES-l1-o1" stroke="#000000" style="fill: red" x="224" y="96" width="28" height="64"></rect>
    <rect id="EDGES-l2-o1" stroke="#000000" style="fill: #26f" transform="translate(128, 18) scale(1, -1) rotate(90) translate(-128, -18) " x="114" y="-14" width="28" height="64"></rect>
    <rect id="EDGES-l3-o1" stroke="#000000" style="fill: orange" x="4" y="96" width="28" height="64"></rect>

    <!-- CORNERS -->
    <use id="CORNERS-l4-o0" href="#sticker" style="fill: yellow"/>
    <use id="CORNERS-l4-o1" href="#sticker" style="fill: limegreen"/>
    <use id="CORNERS-l4-o2" href="#sticker" style="fill: red"/>

    <use id="CORNERS-l5-o0" href="#sticker" style="fill: yellow"/>
    <use id="CORNERS-l5-o1" href="#sticker" style="fill: orange"/>
    <use id="CORNERS-l5-o2" href="#sticker" style="fill: limegreen"/>

    <use id="CORNERS-l6-o0" href="#sticker" style="fill: yellow"/>
    <use id="CORNERS-l6-o1" href="#sticker" style="fill: #26f"/>
    <use id="CORNERS-l6-o2" href="#sticker"  style="fill: orange"/>

    <use id="CORNERS-l7-o0" href="#sticker" style="fill: yellow"/>
    <use id="CORNERS-l7-o1" href="#sticker" style="fill: red"/>
    <use id="CORNERS-l7-o2" href="#sticker" style="fill: #26f"/>

    <!-- EDGES -->
    <use id="EDGES-l4-o0"  href="#sticker" style="fill: yellow"/>
    <use id="EDGES-l4-o1"  href="#sticker" style="fill: limegreen"/>

    <use id="EDGES-l5-o0" href="#sticker" style="fill: yellow"/>
    <use id="EDGES-l5-o1" href="#sticker" style="fill: red"/>

    <use id="EDGES-l6-o0" href="#sticker" style="fill: yellow"/>
    <use id="EDGES-l6-o1" href="#sticker" style="fill: #26f"/>

    <use id="EDGES-l7-o0"  href="#sticker" style="fill: yellow"/>
    <use id="EDGES-l7-o1"  href="#sticker" style="fill: orange"/>

    <use id="EDGES-l8-o0"  href="#sticker" style="fill: limegreen"/>
    <use id="EDGES-l8-o1"  href="#sticker" style="fill: red"/>

    <use id="EDGES-l9-o0"  href="#sticker" style="fill: limegreen"/>
    <use id="EDGES-l9-o1"  href="#sticker" style="fill: orange"/>

    <use id="EDGES-l10-o0" href="#sticker" style="fill: #26f"/>
    <use id="EDGES-l10-o1" href="#sticker" style="fill: red"/>

    <use id="EDGES-l11-o0" href="#sticker" style="fill: #26f"/>
    <use id="EDGES-l11-o1" href="#sticker" style="fill: orange"/>

    <!-- CENTERS -->
    <!-- TODO: Allow the same sticker to be reused for multiple orientations -->
    <use id="CENTERS-l1-o0" href="#sticker" style="fill: orange"/>
    <use id="CENTERS-l1-o1" href="#sticker" style="fill: orange"/>
    <use id="CENTERS-l1-o2" href="#sticker" style="fill: orange"/>
    <use id="CENTERS-l1-o3" href="#sticker" style="fill: orange"/>

    <use id="CENTERS-l2-o0" href="#sticker" style="fill: limegreen"/>
    <use id="CENTERS-l2-o1" href="#sticker" style="fill: limegreen"/>
    <use id="CENTERS-l2-o2" href="#sticker" style="fill: limegreen"/>
    <use id="CENTERS-l2-o3" href="#sticker" style="fill: limegreen"/>

    <use id="CENTERS-l3-o0" href="#sticker" style="fill: red"/>
    <use id="CENTERS-l3-o1" href="#sticker" style="fill: red"/>
    <use id="CENTERS-l3-o2" href="#sticker" style="fill: red"/>
    <use id="CENTERS-l3-o3" href="#sticker" style="fill: red"/>

    <use id="CENTERS-l4-o0" href="#sticker" style="fill: #26f"/>
    <use id="CENTERS-l4-o1" href="#sticker" style="fill: #26f"/>
    <use id="CENTERS-l4-o2" href="#sticker" style="fill: #26f"/>
    <use id="CENTERS-l4-o3" href="#sticker" style="fill: #26f"/>

    <use id="CENTERS-l5-o0" href="#sticker" style="fill: yellow"/>
    <use id="CENTERS-l5-o1" href="#sticker" style="fill: yellow"/>
    <use id="CENTERS-l5-o2" href="#sticker" style="fill: yellow"/>
    <use id="CENTERS-l5-o3" href="#sticker" style="fill: yellow"/>
  </g>
</svg>`;
